import styled from "styled-components";
import { IdentityVerificationDocumentTypeSelector } from "./IdentityVerificationDocumentTypeSelector";
import { IdentityVerificationCountrySelector } from "./IdentityVerificationCountrySelector";
import { IdentityVerificationProcessingState } from "./IdentityVerificationProcessingState";
import { useIdentityVerification } from "src/apps/hooks/identityVerification/useIdentityVerification";
import { OrderStatus } from "src/contexts/documentationArea/domain/OrderStatus";
import { IdentityVerificationUploaders } from "./IdentityVerificationUploaders";
import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";
import { useRef } from "react";
import { useIsMedia } from "src/apps/hooks/useIsMedia";

const SCROLL_DELAY_MS = 100;

export const IdentityVerificationsContent = () => {
  const { isMobile } = useIsMedia();
  const { identityVerificationStatus } = useIdentityVerification();

  const countryRef = useRef<HTMLDivElement>(null);
  const uploadersRef = useRef<HTMLDivElement>(null);

  const scrollToView = (ref: React.RefObject<HTMLDivElement>) => {
    // Delay to allow layout to update before scrolling
    setTimeout(() => {
      scrollIfMobile(ref);
    }, SCROLL_DELAY_MS);
  };

  const scrollIfMobile = (ref: React.RefObject<HTMLDivElement>) => {
    if (!isMobile) return;
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  if (identityVerificationStatus === OrderStatus.PROCESSING)
    return <IdentityVerificationProcessingState />;

  return (
    <Container>
      <SelectsContainer>
        <IdentityVerificationDocumentTypeSelector
          onSelectScrollBehaviour={() => scrollToView(countryRef)}
        />
        <CountrySelectorContainer ref={countryRef}>
          <IdentityVerificationCountrySelector
            onSelectScrollBehaviour={() => scrollToView(uploadersRef)}
          />
        </CountrySelectorContainer>
      </SelectsContainer>
      <UploadersContainer ref={uploadersRef}>
        <IdentityVerificationUploaders />
      </UploadersContainer>
    </Container>
  );
};

const CountrySelectorContainer = styled.div`
  display: flex;
  flex: 1;
`;

const UploadersContainer = styled.div``;

const SelectsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: 2.5rem;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    margin-top: 1rem;
  }
`;
